import { setShowMoveFilesModal } from '../State/showMoveFilesModal';

export default () => async (dispatch) => {
  
  dispatch(setShowMoveFilesModal(false));

}